import { render, staticRenderFns } from "./refundDialog.vue?vue&type=template&id=a158866c&scoped=true"
import script from "./refundDialog.vue?vue&type=script&lang=js"
export * from "./refundDialog.vue?vue&type=script&lang=js"
import style0 from "./refundDialog.vue?vue&type=style&index=0&id=a158866c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a158866c",
  null
  
)

export default component.exports